module.exports = __webpack_public_path__ + "img/qscsancc.d6810c5c.jpg";